import { TRUST_ITEMS } from '../data/site';
import { Icon } from './Icon';
import { Reveal } from './Reveal';

export function TrustStrip() {
  return (
    <section className="trust-strip" aria-label="Razones de confianza">
      <div className="site-container trust-strip__grid">
        {TRUST_ITEMS.map((item, index) => (
          <Reveal as="article" className="trust-strip__item" delay={index * 70} key={item.title}>
            <span className="trust-strip__icon"><Icon name={item.icon} size={32} /></span>
            <div><h2>{item.title}</h2><p>{item.description}</p></div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
